import { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { routesConfig } from "./routesConfig";
import { PrivateRoute } from "./PrivateRoute";
import { PublicRoute } from "./PublicRoute";

/**
 * Build nested routes for each layout tree
 */
const renderRouteTree = (routes: any[], Layout: any, isPrivate: boolean) => {
  const Wrapper = isPrivate ? PrivateRoute : PublicRoute;

  return routes.map(({ path, component: Component, children }: any) => (
    <Route
      key={path}
      path={path}
      element={
        <Wrapper>
          <Layout>
            <Component />
          </Layout>
        </Wrapper>
      }
    >
      {children?.map((child: any) => (
        <Route
          key={child.path}
          path={child.path}
          element={<child.component />}
        />
      ))}
    </Route>
  ));
};


export const AppRoutes = () => (
  <Suspense fallback={<div>Loading...</div>}>
    <Routes>
      {routesConfig.map(({ layout: Layout, routes, isPrivate }) =>
        renderRouteTree(routes, Layout, isPrivate)
      )}
    </Routes>
  </Suspense>
);
